import { emitAuthTrace } from './authTraceClient';

const resolveErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : String(error);

export const traceAuthRefreshStarted = (input: {
  userId: string | null;
  forceRefresh: boolean;
  hasSignedInSignal: boolean;
  hasCurrentSession: boolean;
}): void => {
  emitAuthTrace({
    event: 'auth_refresh_started',
    userId: input.userId,
    detail: {
      forceRefresh: input.forceRefresh,
      hasSignedInSignal: input.hasSignedInSignal,
      hasCurrentSession: input.hasCurrentSession,
    },
  });
};

export const traceAuthRefreshCompleted = (input: {
  userId: string | null;
  forceRefresh: boolean;
  outcome:
    | 'refreshed'
    | 'missing_user_terminal'
    | 'preserved_signed_out_signal'
    | 'preserved_refresh_miss'
    | 'cleared_signed_out_signal'
    | 'cleared_refresh_miss'
    | 'rate_limited'
    | 'preserved_auth_error'
    | 'expired_auth_error'
    | 'expired_unexpected_error';
  didRefresh: boolean;
  expiresAt: number | null;
}): void => {
  emitAuthTrace({
    event: 'auth_refresh_completed',
    userId: input.userId,
    detail: {
      forceRefresh: input.forceRefresh,
      outcome: input.outcome,
      didRefresh: input.didRefresh,
      expiresAt: input.expiresAt,
    },
  });
};

export const traceAuthRefreshFailed = (input: {
  userId: string | null;
  forceRefresh: boolean;
  status: number | null;
  code: string | null;
  error: unknown;
}): void => {
  emitAuthTrace({
    event: 'auth_refresh_failed',
    userId: input.userId,
    detail: {
      forceRefresh: input.forceRefresh,
      status: input.status,
      code: input.code,
      error: resolveErrorMessage(input.error),
    },
  });
};

export const traceAuthSessionExpired = (input: {
  userId: string | null;
  reason: 'timer' | 'refresh_error' | 'session_expired_event';
}): void => {
  emitAuthTrace({
    event: 'auth_session_expired',
    userId: input.userId,
    detail: {
      reason: input.reason,
    },
  });
};
